import { INavDisplayOptions } from '../model/nav-display-options.interface';
import { navigationConfig } from '../config/navigation.config';
import { INavGraphDisplayOptionEdges } from '../model/nav-display-edgegroup-pairs';
import { INavRequestOption } from '../model/nav-request-option.interface';
import { INavGraph2EdgeDefinitionConfig } from '../model/nav-graph2-edgedef-config.interface';

// -- 0. Reset State ------------------------------------------------------------------------------
export const NAVIGATION_RESET_STATE_ALL_EXCEPT_CONFIG = 'NAVIGATION_RESET_STATE_ALL_EXCEPT_CONFIG';

// -- 1. Initial Config ---------------------------------------------------------------------------
export const NAVIGATION_STORE_CONFIG = 'NAVIGATION_STORE_CONFIG';

// -- 2. Element Graph ------------------------------------------------------------------------------
export const NAVIGATION_STORE_RESULT_1ST_INITIAL = 'NAVIGATION_STORE_RESULT_1ST_INITIAL';
export const NAVIGATION_STORE_RESULT_1ST_EXTENDED = 'NAVIGATION_STORE_RESULT_1ST_EXTENDED';
export const NAVIGATION_STORE_RESULT_1ST_DETAIL = 'NAVIGATION_STORE_RESULT_1ST_DETAIL';
export const NAVIGATION_STORE_1ST_DISPLAY_OPTIONS = 'NAVIGATION_STORE_1ST_DISPLAY_OPTIONS';
export const NAVIGATION_STORE_1ST_REQUEST_OPTIONS = 'NAVIGATION_STORE_1ST_REQUEST_OPTIONS';
export const NAVIGATION_STORE_1ST_AVAILABLE_EDGEGROUP_PAIRS = 'NAVIGATION_STORE_1ST_AVAILABLE_EDGEGROUP_PAIRS';
export const NAVIGATION_STORE_1ST_DISPLAY_OPTION_EDGES = 'NAVIGATION_STORE_1ST_DISPLAY_OPTION_EDGES';

// -- 3. Search Graph ------------------------------------------------------------------------------
export const NAVIGATION_STORE_RESULT_2ND_INITIAL = 'NAVIGATION_STORE_RESULT_2ND_INITIAL';
export const NAVIGATION_STORE_RESULT_2ND_EXTENDED = 'NAVIGATION_STORE_RESULT_2ND_EXTENDED';
export const NAVIGATION_STORE_RESULT_2ND_DETAIL = 'NAVIGATION_STORE_RESULT_2ND_DETAIL';
export const NAVIGATION_STORE_2ND_DISPLAY_OPTIONS = 'NAVIGATION_STORE_2ND_DISPLAY_OPTIONS';
export const NAVIGATION_STORE_2ND_REQUEST_OPTIONS = 'NAVIGATION_STORE_2ND_REQUEST_OPTIONS';
export const NAVIGATION_STORE_2ND_AVAILABLE_EDGEGROUP_PAIRS = 'NAVIGATION_STORE_2ND_AVAILABLE_EDGEGROUP_PAIRS';
export const NAVIGATION_STORE_2ND_DISPLAY_OPTION_EDGES = 'NAVIGATION_STORE_2ND_DISPLAY_OPTION_EDGES';
export const NAVIGATION_STORE_2ND_EDGE_DEFINITION_CONFIG = 'NAVIGATION_STORE_2ND_EDGE_DEFINITION_CONFIG';

// -- 4. Schema -----------------------------------------------------------------------------------
export const NAVIGATION_STORE_SCHEMA = 'NAVIGATION_STORE_SCHEMA';

// ------------------------------------------------------------------------------------------------
// action creators
// ------------------------------------------------------------------------------------------------

// -- 0. Reset State ------------------------------------------------------------------------------
export function navigationResetStateAllExceptConfig() {
   return { type: NAVIGATION_RESET_STATE_ALL_EXCEPT_CONFIG, payload: '' };
}

// -- 1. Initial Config ---------------------------------------------------------------------------
export function navigationStoreConfig(jsObj: any) {
   return { type: NAVIGATION_STORE_CONFIG, payload: { object: jsObj } };
}

// -- 2. Element Graph ------------------------------------------------------------------------------
export function navigationStoreResult1stInit(jsObj: any) {
   return { type: NAVIGATION_STORE_RESULT_1ST_INITIAL, payload: { object: jsObj } };
}
export function navigationStoreResult1stExtended(jsObj: any) {
   return { type: NAVIGATION_STORE_RESULT_1ST_EXTENDED, payload: { object: jsObj } };
}
export function navigationStoreResult1stDetail(jsObj: any) {
   return { type: NAVIGATION_STORE_RESULT_1ST_DETAIL, payload: { object: jsObj } };
}

export function navigationStore1stDisplayOptions(options: INavDisplayOptions) {
   return { type: NAVIGATION_STORE_1ST_DISPLAY_OPTIONS, payload: { object: options } };
}
export function navigationStore1stRequestOptions(options: INavRequestOption) {
   return { type: NAVIGATION_STORE_1ST_REQUEST_OPTIONS, payload: { object: options } };
}

export function navigationStoreResult1stInitialValue() {
   return {
      type: NAVIGATION_STORE_RESULT_1ST_INITIAL, payload: {
         object:
            Object.assign(
               navigationConfig.elementsResultInitial
            )
      }
   };
}

export function navigationStore1stDisplayOptionEdges(jsObj: INavGraphDisplayOptionEdges[]) {
   return { type: NAVIGATION_STORE_1ST_DISPLAY_OPTION_EDGES, payload: { object: jsObj } };
}

// -- 3. Search Graph -----------------------------------------------------------------------------
export function navigationStoreResult2stInit(jsObj: any) {
   return { type: NAVIGATION_STORE_RESULT_2ND_INITIAL, payload: { object: jsObj } };
}
export function navigationStoreResult2stExtended(jsObj: any) {
   return { type: NAVIGATION_STORE_RESULT_2ND_EXTENDED, payload: { object: jsObj } };
}
export function navigationStoreResult2stDetail(jsObj: any) {
   return { type: NAVIGATION_STORE_RESULT_2ND_DETAIL, payload: { object: jsObj } };
}

export function navigationStore2stDisplayOptions(options: INavDisplayOptions) {
   return { type: NAVIGATION_STORE_2ND_DISPLAY_OPTIONS, payload: { object: options } };
}
export function navigationStore2stRequestOptions(options: INavRequestOption) {
   return { type: NAVIGATION_STORE_2ND_REQUEST_OPTIONS, payload: { object: options } };
}

export function navigationStoreResult2stInitialValue() {
   return {
      type: NAVIGATION_STORE_RESULT_2ND_INITIAL, payload: {
         object:
            Object.assign(
               navigationConfig.elementsResultInitial
            )
      }
   };
}

export function navigationStore2stDisplayOptionEdges(jsObj: INavGraphDisplayOptionEdges[]) {
   return { type: NAVIGATION_STORE_2ND_DISPLAY_OPTION_EDGES, payload: { object: jsObj } };
}

export function navigationStore2stEdgeDefinitionConfig(jsObj: INavGraph2EdgeDefinitionConfig) {
   return { type: NAVIGATION_STORE_2ND_EDGE_DEFINITION_CONFIG, payload: { object: jsObj } };
}

// -- 4. Schema -----------------------------------------------------------------------------------
export function navigationStoreSchema(jsObj: any) {
   return { type: NAVIGATION_STORE_SCHEMA, payload: { object: jsObj } };
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/store/actions.ts